
/**
 * A helper to scroll to an element by ID on click.
 *
 * @param id
 *   The ID of the element to scroll to without the # prefix.
 * @param callback
 *   An optional callback.
 * @param props
 *   Additional div properties.
 * @constructor
 */
export function ScrollLink ({id, callback, ...props}) {

  async function scrollTo() {
    const element = document.getElementById(id);
    if (element) {
      if (callback) callback();
      element.scrollIntoView({behavior: "smooth"});
    }
  }

  return (
    <div className="cursor-pointer">
      <div onClick={scrollTo} {...props}>{props.children}</div>
    </div>
  )
}